import React from "react";
import MonitoringTabsPanel from "components/common/MonitoringTabsPanel";
import MonitoringCgsDashboard from "pages/Monitoring/MonitoringCgsDashboard";
import MonitoringCgsProvider from "providers/MonitoringCgsProvider";

const MonitoringCgsPage: React.FC = () => (
  <MonitoringTabsPanel>
    {(tab) => (
      <MonitoringCgsProvider>
        <MonitoringCgsDashboard tab={tab} />
      </MonitoringCgsProvider>
    )}
  </MonitoringTabsPanel>
);

export default MonitoringCgsPage;
